import { useRef } from 'react';
import { t } from '@lingui/core/macro';
import { PreviewTypes } from 'shared/domains/documents/utils/types';
import { useDimensions } from './useDimensions';
import { SkipDocumentContent } from '../../SkipDocumentContent';
import { ErrorAlert } from '../ErrorAlert';
import { Loader } from '../Loader';
import { PasswordProtected } from '../PasswordProtected';
import { Toolbar } from '../Toolbar';
import { VirtualizedList } from '../VirtualizedList';
import { useStrictPDFData } from '../usePDFData';
import { Content, Container } from './styled';
export function Preview() {
    const { loading, error, passwordProtected } = useStrictPDFData();
    const endOfDocumentId = 'end-of-document';
    const zoomRef = useRef(null);
    const { zoom, zoomTo } = useDimensions({
        ref: zoomRef,
        disableZoom: false,
        previewType: PreviewTypes.PDF,
    });
    if (passwordProtected) {
        return <PasswordProtected />;
    }
    if (error) {
        return <ErrorAlert />;
    }
    if (loading) {
        return <Loader message={t({ message: 'Loading PDF...', comment: 'Message when loading a PDF' })}/>;
    }
    return (<Container>
      <Toolbar zoom={zoom} zoomTo={zoomTo}/>
      <Content>
        <SkipDocumentContent target={endOfDocumentId}/>
        <VirtualizedList zoom={zoom} zoomRef={zoomRef}/>
        <div id={endOfDocumentId}/>
      </Content>
    </Container>);
}
